<template>
    <div class="flex menu px-4 justify-content-between relative">
        <div class="menu-list flex gap-4 align-items-center">
            <router-link :to="getHomeUrl()">
                <img src="@/assets/icons/home.png" alt="Link to homepage" class="home-link mr-3">
            </router-link>
            <i class="pi pi-bars menu-button ml-3" @click.stop="toggleMenu" />
            <div class="menu-list-items flex gap-4 h-full align-items-center">
                <div v-for="(item, index) in itemsByRole" :key="index" class="menu-list-item h-full flex relative">
                    <router-link v-if="item.to" v-slot="{ href,navigate }" :to="item.to" custom>
                        <a class="underscore-link align-items-center flex cursor-pointer p-1 m-3" :href="href" @click="navigate">
                            {{ item.label }}
                        </a>
                    </router-link>
                    <div v-else class="flex align-items-center cursor-pointer p-1 submenu-button h-full"
                        @mouseenter="showSubmenu(index)" @mouseleave="delayedHideSubmenu(index)">
                        <span class="mr-2 m-3">{{ item.label }}</span>
                        <span v-if="item.items && item.items.length > 0" class="pi pi-chevron-down"></span>
                        <div v-if="item.items && item.items.length > 0" class="submenu"
                             v-show="submenuVisible[index]"
                             @mouseenter="cancelHide" @mouseleave="hideSubmenu(item.label)">
                            <div v-for="item in item.items" class="flex">
                                <router-link v-slot="{ href,navigate }" :to="item.to" custom>
                                    <a class="underscore-link cursor-pointer p-1 m-3" :href="href" @click="navigate">
                                        {{ item.label }}
                                    </a>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <PanelMenu :model="itemsByRole" class="menu-list-items-mobile" v-model:expandedKeys="expandedKeys">
                <template #item="{ item }">
                    <div class="menu-list-item">
                        <router-link v-if="item.to" v-slot="{ href,navigate }" :to="item.to" custom @click="hideMobileMenu">
                            <a class="mobile-navigate underscore-link align-items-center flex cursor-pointer p-1 m-3" :href="href" @click="navigate">
                                <span>{{ item.label }}</span>
                            </a>
                        </router-link>
                        <a v-else class="flex align-items-center cursor-pointer justify-content-between w-full p-1 m-3" :href="item.url" :target="item.target" @click="openCloseSubmenu(item)">
                            <span>{{ item.label }}</span>
                            <span v-if="item.items && item.items.length > 0 && !item.arrowUp" class="pi pi-chevron-down"></span>
                            <span v-if="item.items && item.items.length > 0 && item.arrowUp" class="pi pi-chevron-up"></span>
                        </a>
                    </div>
                </template>
            </PanelMenu>
        </div>

        <div class="right-side flex align-items-center gap-5">
            <!--<CustomButton label="T" @click="switchThoroughbred" />
            <CustomButton label="A" @click="switchArabPureBlood" />-->
            <div class="flex justify-content-center align-items-center gap-5 relative h-full icons-box">
                <i class="pi pi-user cursor-pointer" @click="toggleUserData" />
                <i class="pi pi-sign-out cursor-pointer" title="Log out" @click="logoutUser" @keydown.enter="logoutUser" />
                <div class="absolute user-menu">
                    <div class="capitalize text-xl mb-2 pt-3 px-3">{{ fullName }}</div>
                    <div class="uppercase text-base pb-3 px-3">{{ roleName }}</div>
                </div>
            </div>
            <img :src="logoSrc" alt="logo" class="logo">
        </div>
    </div>
</template>

<script>
    import _ from 'lodash';
    import PanelMenu from "primevue/panelmenu";
    import CustomButton from "@/components/form/CustomButton.vue";
    import {SystemRole} from "@/utils/SystemRole";
    import {logout} from "@/swagger/vue-api-client";
    import lhaLogo from "@/assets/lha-logo-beige.png"
    import arabianLogo from "@/assets/arabianLogo.png"

    export default {
        name: "AppMenu",

        components: {
            CustomButton,
            PanelMenu,
        },

        data() {
            return {
                expandedKeys: {},
                hideTimeout: null,
                submenuVisible: [false, false],
                items: [
                    {
                        label: this.$t("message.menu.horses"),
                        to: "/horse/list",
                        key: "0",
                        roles: [SystemRole.ADMIN, SystemRole.FIRST_LEVEL_EDITOR, SystemRole.SECOND_LEVEL_EDITOR, SystemRole.THIRD_LEVEL_EDITOR, SystemRole.FOURTH_LEVEL_EDITOR, SystemRole.VIEWER],
                    },
                    {
                        label: this.$t("message.menu.pending"),
                        to: "/pending/list",
                        key: "1",
                        roles: [SystemRole.ADMIN, SystemRole.FIRST_LEVEL_EDITOR, SystemRole.SECOND_LEVEL_EDITOR, SystemRole.THIRD_LEVEL_EDITOR, SystemRole.FOURTH_LEVEL_EDITOR, SystemRole.LAB_USER],
                    },
                    {
                        label: this.$t("message.menu.stallions"),
                        to: "/stallions/list",
                        key: "2",
                        roles: [SystemRole.ADMIN, SystemRole.FIRST_LEVEL_EDITOR, SystemRole.SECOND_LEVEL_EDITOR, SystemRole.THIRD_LEVEL_EDITOR, SystemRole.FOURTH_LEVEL_EDITOR],
                    },
                    {
                        label: this.$t("message.menu.broodmares"),
                        to: "/broodmares/list",
                        key: "3",
                        roles: [SystemRole.ADMIN, SystemRole.FIRST_LEVEL_EDITOR, SystemRole.SECOND_LEVEL_EDITOR, SystemRole.THIRD_LEVEL_EDITOR, SystemRole.FOURTH_LEVEL_EDITOR],
                    },
                    {
                        label: this.$t("message.menu.breedersAndOwners"),
                        to: "/owners-and-breeders/list",
                        key: "4",
                        roles: [SystemRole.ADMIN, SystemRole.FIRST_LEVEL_EDITOR, SystemRole.SECOND_LEVEL_EDITOR, SystemRole.THIRD_LEVEL_EDITOR],
                    },
                    // {
                    //     label: this.$t("message.menu.studbook"),
                    //     to: "/studbook",
                    //     key: "5",
                    // },
                    {
                        key: "5",
                        label: this.$t("message.menu.dictionaries"),
                        to: "",
                        roles: [SystemRole.ADMIN],
                        items: [
                            {
                                key: "5_1",
                                label: this.$t("message.menu.studbookTypes"),
                                to: "/book-type/list",
                                roles: [SystemRole.ADMIN],
                            },
                            {
                                key: "5_2",
                                label: this.$t("message.menu.horseColors"),
                                to: "/horse-color/list",
                                roles: [SystemRole.ADMIN],
                            },
                            {
                                key: "5_3",
                                label: this.$t("message.menu.eventTypes"),
                                to: "/event-type/list",
                                roles: [SystemRole.ADMIN],
                            },
                            {
                                key: "5_4",
                                label: this.$t("message.menu.forbiddenNames"),
                                to: "/forbidden-name/list",
                                roles: [SystemRole.ADMIN],
                            },
                            {
                                key: "5_4",
                                label: this.$t("message.menu.seasons"),
                                to: "/season/list",
                                roles: [SystemRole.ADMIN],
                            },
                        ],
                    },
                    {
                        key: "6",
                        label: this.$t("message.menu.advanced"),
                        to: "",
                        roles: [SystemRole.ADMIN, SystemRole.THIRD_LEVEL_EDITOR, SystemRole.FOURTH_LEVEL_EDITOR],
                        items: [
                            {
                                key: "6_1",
                                label: this.$t("message.menu.users"),
                                to: "/user/list",
                                roles: [SystemRole.ADMIN],
                            },
                            {
                                key: "6_2",
                                label: this.$t("message.menu.laboratories"),
                                to: "/laboratories/list",
                                roles: [SystemRole.ADMIN],
                            },
                            {
                                key: "6_3",
                                label: this.$t("message.menu.documents"),
                                to: "/documents/list",
                                roles: [SystemRole.ADMIN, SystemRole.THIRD_LEVEL_EDITOR, SystemRole.FOURTH_LEVEL_EDITOR],
                            },
                            {
                                key: "6_4",
                                label: this.$t("message.menu.filters"),
                                to: "/filters",
                                roles: [SystemRole.ADMIN, SystemRole.THIRD_LEVEL_EDITOR, SystemRole.FOURTH_LEVEL_EDITOR],
                            },
                            {
                                key: "6_5",
                                label: this.$t("message.menu.history"),
                                to: "/history/list",
                                roles: [SystemRole.ADMIN, SystemRole.FOURTH_LEVEL_EDITOR, SystemRole.THIRD_LEVEL_EDITOR,
                                    SystemRole.SECOND_LEVEL_EDITOR, SystemRole.FIRST_LEVEL_EDITOR],
                            },
                        ],
                    },
                ],
                logoSrc: document.body.classList.contains('arab-horses') ? arabianLogo : lhaLogo,
            };
        },

        mounted() {
            document.addEventListener('click', function(event) {
                const menu = document.querySelector(".menu-list-items-mobile");
                if (menu && menu.classList.contains("active")) {
                    menu.classList.remove("active");
                }
            });
        },

        methods: {
            clearLocalUserData() {
                const keysToRemove = ["horseBreed", "token", "role", "roleName", "fullName"];
                keysToRemove.forEach(key => localStorage.removeItem(key));
            },
            async logoutUser() {
                try {
                    await logout();
                    window.console.debug("Backend logout successful");
                } catch (error) {
                    window.console.error("Backend logout failed, forcing local logout", error);
                } finally {
                    this.clearLocalUserData();
                    this.$router.push({ name: "login" });
                }
            },
            showSubmenu(index) {
                this.submenuVisible[index] = true;
            },
            delayedHideSubmenu(index) {
                // this.hideTimeout = setTimeout(() => {
                // }, 300);
                this.hideSubmenu(index);
            },
            hideSubmenu(index) {
                this.submenuVisible[index] = false;
            },
            // cancelHide() {
            //     clearTimeout(this.hideTimeout);
            // },
            toggleUserData() {
                const userMenu = document.querySelector(".user-menu");
                userMenu.classList.toggle("active");
            },
            toggleMenu() {
                const menu = document.querySelector(".menu-list-items-mobile");
                menu.addEventListener('click', function(event) {
                    event.stopPropagation();
                });
                menu.classList.toggle("active");
            },
            hideMobileMenu() {
                const menu = document.querySelector(".menu-list-items-mobile");
                menu.classList.remove("active");
                this.expandedKeys = {};
                this.items.forEach((it) => {
                    if (it.arrowUp) {
                        it.arrowUp = false;
                    }
                });
            },
            openCloseSubmenu(item) {
                item.arrowUp = !item.arrowUp;
                this.items.forEach((it) => {
                    if (!_.isEqual(it, item) && it.arrowUp) {
                        it.arrowUp = false;
                    }
                });
            },
            switchArabPureBlood() {
                const vueApp = document.querySelector("#vue-app");
                vueApp.classList.add('arab-horses');
            },
            switchThoroughbred() {
                const vueApp = document.querySelector("#vue-app");
                vueApp.classList.remove('arab-horses');
            },
            getHomeUrl() {
                const userRole = SystemRole.getUserRole();

                switch (userRole) {
                    case SystemRole.LAB_USER:
                        return "/pending/list";
                    default:
                        return "/home";
                }
            },
        },

        computed: {
            fullName() {
                return localStorage.getItem("fullName") || "";
            },
            roleName() {
                return localStorage.getItem("roleName") || "";
            },
            itemsByRole() {
                const userRole = SystemRole.getUserRole();

                const filterByRole = (items) => {
                    return items
                        .map(item => {
                            const newItem = { ...item };

                            // If the item has subitems, apply filtering recursively.
                            if (newItem.items && Array.isArray(newItem.items)) {
                                newItem.items = filterByRole(newItem.items);
                            }

                            const isItemAllowed =
                                !newItem.roles ||
                                !Array.isArray(newItem.roles) ||
                                newItem.roles.length === 0 ||
                                newItem.roles.includes(userRole);

                            // Return the item only if:
                            //  - It is allowed based on its own roles, or
                            //  - It contains subitems (after filtering) that are allowed.
                            if (isItemAllowed || (newItem.items && newItem.items.length > 0)) {
                                return newItem;
                            }
                            return null; // Mark item as not allowed
                        })
                        .filter(item => item !== null); // Remove items that are not allowed
                };

                return filterByRole(this.items);
            }
        },
    };
</script>

<style lang="scss">
@import "../assets/theme/mytheme/variables";
.menu {
    font-family: var(--decor-font-family);
    font-size: 1.2rem;
    text-transform: uppercase;
    background-color: var(--menu-background-color);
    color: var(--menu-text-color) !important;
    height: $top-bar-height;
    .underscore-link {
        color: var(--menu-text-color) !important;
        border-bottom: solid 1px var(--menu-background-color);
        transition: border-bottom 0.2s;
    }
    .underscore-link:hover {
        border-bottom: solid 1px var(--menu-text-color);
    }
    i {
        font-size: 1.5rem;
    }
    @media screen and (max-width: 1600px) {
        // a, .submenu-button {
        //     margin: 0 !important;
        // }
        font-size: 1rem;
        &-list {
            gap: 0.5rem !important;
        }
        &-list-items {
            gap: 0.5rem !important;
        }
    }
    @media screen and (max-width: 1360px) {
        // &-list-items {
        //     gap: 1rem !important;
        // }
        .menu-list-item {
            a, div > span {
                margin-left: 0.25rem !important;
                margin-right: 0.25rem !important;
            }
        }
    }
    @media screen and (max-width: 1230px) {
        .menu-list-items {
            display: none !important;
        }
    }
    &-button {
        display: none;
        @media screen and (max-width: 1230px) {
            display: block;
        }
    }
    &-list-items-mobile {
        display: none;
        .p-panelmenu-panel {
            width: 100%;
        }
        .p-panelmenu-header:focus {
            .p-panelmenu-header-content {
                outline: none !important;
                border: none !important;
                box-shadow: none !important;
            }
        }
        @media screen and (max-width: 1230px) {
            display: flex;
            align-items: center;
            gap: 1.5rem;
            position: absolute;
            flex-direction: column;
            background: var(--menu-background-color);
            max-height: 0;
            z-index: 999999;
            top: $top-bar-height - 1px;
            left: 0;
            align-items: flex-start;
            gap: 0;
            transition: 1s ease-in-out;
            overflow: hidden;
            .menu-list-item {
                padding: 0.5rem 1.5rem;
            }
            &.active {
                max-height: 1000px;
            }
        }
    }
}
.submenu {
    position: absolute;
    top: $top-bar-height;
    z-index: 1000;
    background-color: var(--submenu-color);
    padding: 0.2rem 1rem;
    // margin-left: -20rem;
    transform: translateX(-50%);
    width: max-content;
    left: 50%;
    display: flex;

    .underscore-link {
        border-bottom: solid 1px var(--submenu-color);
    }
}
.logo {
    height: 75px;
    padding: 0.25rem;
}
.home-link {
    height: 25px;
}
.user-menu {
    top: 100%;
    left: 0;
    transform: translateX(-40%);
    max-height: 0;
    overflow: hidden;
    width: max-content;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--menu-background-color);
    flex-direction: column;
    transition: 1s ease-in-out;
    z-index: 999;
    &.active {
        max-height: 200px;
    }
}
@media screen and (max-width: 400px) {
    .home-link {
        margin-right: 0 !important;
    }
    .right-side {
        gap: 0.5rem !important;
        .icons-box {
            gap: 1rem !important;
        }
    }
}
</style>
